import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const AssignDescriptions = styled(Box)(() => ({
  marginBottom: 20,
}));

export const AssignNotes = styled(Box)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '21px',
  fontStyle: 'italic',
  color: theme.palette.text.primary,
  marginBottom: 10,
}));

export const SerialInput = styled(Box)(() => ({
  textTransform: 'uppercase',
  fontWeight: 500,
  letterSpacing: '1rem',
}));

export const StatusLabelTitle = styled(Box)(() => ({
  fontSize: 12,
}));

export const AssignDescription = styled(Box)(({ theme }) => ({
  display: 'block',
  fontSize: 10,
  fontWeight: 700,
  lineHeight: 2,
  color: theme.palette.text.secondary,
}));
